import { MouseEvent, useEffect, useMemo, useState } from 'react'

type ButtonMouseEvent = MouseEvent<HTMLButtonElement>

export const useDelayedSelection = (
  onClick: (name: string) => void,
  initial?: string | null | undefined,
): [string | null, (event: ButtonMouseEvent) => void] => {
  const [selection, setSelection] = useState<string | null>(null)

  useEffect(() => {
    setSelection(initial || null)
  }, [initial])

  return useMemo(
    () => [
      selection,
      (event: ButtonMouseEvent) => {
        const name = event.currentTarget.name
        setSelection(name)
        setTimeout(() => onClick(name), 400)
      },
    ],
    [selection, onClick],
  )
}
